import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
`;

const Text = styled.p`
  font-size: ${({ fontSize }) => fontSize || '14px'};
  color: ${({ theme }) => theme.colors.textGray.secondary};
  margin: 0 0 12px 0;
  line-height: 1.6;
  white-space: pre-wrap;
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-top: 4px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  font-weight: 500;
  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
`;

/**
 * CollapsibleText - Displays text that collapses if it exceeds a character limit
 *
 * @param {string} text - The text content to display
 * @param {number} maxLength - Maximum characters before collapsing (default: 300)
 * @param {string} showMoreLabel - Label for expand button (default: "Show more")
 * @param {string} showLessLabel - Label for collapse button (default: "Show less")
 * @param {string} fontSize - Font size for the text (default: "14px")
 * @param {string} className - Additional className for styling
 */
const CollapsibleText = ({
  text,
  maxLength = 300,
  showMoreLabel = 'Show more',
  showLessLabel = 'Show less',
  fontSize,
  className,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) {
    return null;
  }

  const shouldCollapse = text.length > maxLength;
  const displayText =
    shouldCollapse && !isExpanded ? `${text.slice(0, maxLength)}...` : text;

  return (
    <Container className={className}>
      <Text fontSize={fontSize}>{displayText}</Text>
      {shouldCollapse && (
        <ToggleButton
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
          aria-expanded={isExpanded}
        >
          {isExpanded ? showLessLabel : showMoreLabel}
        </ToggleButton>
      )}
    </Container>
  );
};

export default CollapsibleText;
